import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=e1cd10a8&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cd10a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1cd10a8')) {
      api.createRecord('e1cd10a8', component.options)
    } else {
      api.reload('e1cd10a8', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=e1cd10a8&scoped=true&", function () {
      api.rerender('e1cd10a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y4WXRjo6y6H0/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports